module.exports = __webpack_public_path__ + "img/stock1.80a84d24.png";